import React, { useState, useEffect } from 'react';
import { megaPrizeAPI } from '../services/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Trophy } from 'lucide-react';
import { FoxSpinnerInline } from '../components/ui/FoxSpinner';

const MegaPremioPublic = () => {
  const [config, setConfig] = useState(null);
  const [winner, setWinner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [configRes, winnerRes] = await Promise.all([
        megaPrizeAPI.getConfig(),
        megaPrizeAPI.getCurrentWinner()
      ]);
      setConfig(configRes.data);
      setWinner(winnerRes.data);
    } catch (error) {
      console.error('Erro:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-yellow-100 via-orange-100 to-pink-100 flex items-center justify-center">
        <FoxSpinnerInline size="lg" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-100 via-orange-100 to-pink-100 p-4">
      <div className="max-w-4xl mx-auto py-8 space-y-6">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-5xl font-bold mb-4">
            <span className="text-orange-500">🦊 FOX</span>{' '}
            <span className="text-purple-600">SELLER</span>
          </h1>
          <div className="flex items-center justify-center gap-3">
            <Trophy className="h-12 w-12 text-yellow-600" />
            <h2 className="text-4xl font-bold text-yellow-700">MEGA PRÊMIO</h2>
          </div>
        </div>

        {/* Prêmio Acumulado */}
        {config && config.active && (
          <Card className="border-4 border-yellow-400 bg-white shadow-2xl">
            <CardContent className="p-12 text-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_pixcoinshop/artifacts/z8ldhg31_IMG_8069.PNG"
                alt="Prêmio Acumulado"
                className="h-40 mx-auto mb-6"
              />
              <p className="text-7xl font-black text-yellow-600 mb-4">
                {config.current_prize?.toLocaleString() || 0}
              </p>
              <p className="text-3xl text-yellow-700">🎁 moedas</p>
              <p className="text-lg text-gray-600 mt-6">{config.total_tickets || 0} tickets participando</p>
            </CardContent>
          </Card>
        )}

        {/* Botão CTA */}
        {config && config.active && (
          <div className="text-center">
            <a href="/">
              <button className="bg-gradient-to-r from-orange-500 to-red-600 text-white text-2xl font-bold px-12 py-6 rounded-lg shadow-2xl hover:from-orange-600 hover:to-red-700 transition-all transform hover:scale-105">
                🛒 COMPRE AGORA MESMO!
              </button>
            </a>
          </div>
        )}

        {/* Ganhador */}
        {winner && winner.winner_kako_id && (
          <Card className="border-4 border-green-400">
            <CardHeader>
              <CardTitle className="text-center text-3xl">🏆 GANHADOR</CardTitle>
            </CardHeader>
            <CardContent className="text-center space-y-6">
              {winner.winner_avatar && (
                <div className="relative w-48 h-48 mx-auto">
                  <img src={winner.winner_avatar} className="w-32 h-32 rounded-full absolute z-0 object-cover" style={{ left: '50%', top: '50%', transform: 'translate(-50%, -50%) translateY(-8px)' }} />
                  <img src="https://customer-assets.emergentagent.com/job_pixcoinshop/artifacts/ggwpuckl_image.png" className="w-full h-full object-contain absolute inset-0 z-10" />
                </div>
              )}
              <p className="text-4xl font-bold">{winner.winner_nickname}</p>
              <div className="bg-yellow-50 p-6 rounded-lg">
                <p className="text-xl text-gray-600 mb-2">Prêmio</p>
                <p className="text-5xl font-black text-yellow-600">{winner.prize_amount?.toLocaleString()}</p>
                <p className="text-2xl text-yellow-700 mt-2">🎁 moedas</p>
              </div>
              <div className="flex justify-center gap-2">
                {winner.drawn_numbers_str?.split('-').map((num, idx) => (
                  <div key={idx} className="w-12 h-12 rounded-full bg-green-500 text-white text-xl font-bold flex items-center justify-center">
                    {num}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        )}

        {/* Regras */}
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">📋 Regras</CardTitle>
          </CardHeader>
          <CardContent className="max-h-96 overflow-y-auto">
            {config?.rules_text ? (
              <div className="whitespace-pre-line text-gray-700">
                {config.rules_text}
              </div>
            ) : (
              <div className="text-gray-700 space-y-3">
                <p>✅ Compre pacotes de <strong>{config?.min_order_coins?.toLocaleString() || 10000} moedas</strong> ou mais</p>
                <p>✅ Receba 1 ticket com 6 dezenas aleatórias (01-60)</p>
                <p>✅ Cada pedido adiciona <strong>{config?.prize_increment || 100} moedas</strong> ao prêmio</p>
                <p>🏆 Ganha quem acertar <strong>6, 5 ou 4 dezenas</strong></p>
                <p>💰 Prêmio <strong>ACUMULA</strong> se ninguém ganhar!</p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default MegaPremioPublic;
